import * as actionTypes from '../types/correctionSemiProducts';

export function getSemiProductByReady(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCT_BY_READY,
    payload
  };
}

export function getSemiProductByReadySuccess(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCT_BY_READY_SUCCESS,
    payload
  };
}

export function getSemiProductByReadyFail(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCT_BY_READY_FAIL,
    payload
  };
}

export function getCorrectionSemi(payload) {
  return {
    type: actionTypes.GET_CORRECTION_SEMI,
    payload
  };
}

export function getCorrectionSemiSuccess(payload) {
  return {
    type: actionTypes.GET_CORRECTION_SEMI_SUCCESS,
    payload
  };
}

export function getCorrectionSemiFail(payload) {
  return {
    type: actionTypes.GET_CORRECTION_SEMI_FAIL,
    payload
  };
}


export function clearCorrectionSemiProductsClear(payload) {
  return {
    type: actionTypes.CLEAR_CORRECTION_SEMI_PRODUCTS,
    payload
  };
}
